<div class="modal-header b px-5">
  <h6 class="modal-title font-weight-500 text-defualt">Call log</h6>
  <button data-testid="auto-app-edit-call-log-settings-button-1" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close" (click)="dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form [formGroup]="addOrEditCallLog"  (ngSubmit)="addNewCallOutcome()" >
  <div class="modal-body px-5">
    <div class="form-group mb-0">
      <div class="row mb-6">
            <div class="col">
              <label for="outcometype" class="f-12">Outcomes type <span class="text-danger">*</span>
              </label>
              <div class="position-relative">
                <select data-testid="auto-app-edit-call-log-settings-select-1"  class="defaultText" name="outcometype" id="outcometype" class="wc-form-control nobg" formControlName="newOutcomeType">
                  <option class="defaultText" value="null" disabled selected>Select outcome type</option>
                  <option class="optionText" value="Positive">Positive</option>
                  <option class="optionText" value="Negative">Negative</option>
                  <option class="optionText" value="Neutral">Neutral</option>
                </select>

                <span
                *ngIf="addOrEditCallLog.get('newOutcomeType').errors && addOrEditCallLog.get('newOutcomeType').touched || addOrEditCallLog.get('newOutcomeType').dirty">
                <p *ngIf="addOrEditCallLog.get('newOutcomeType').errors?.required" class="f-12 mt-1 text-danger">
                    Outcomes type is required
                </p>
              </span>
              </div>
            </div>    
      </div>
      <div class="row mb-6">
        <div class="col">
          <label for="outcomename" class="f-12">Outcomes <span class="text-danger">*</span>
          </label>
          <div class="position-relative">
            <input data-testid="auto-app-edit-call-log-settings-input-1" type="text" placeholder="Enter Outcomes Name" formControlName="newOutcome"
              class="wc-form-control nobg">

              <span
              *ngIf="addOrEditCallLog.get('newOutcome').errors && addOrEditCallLog.get('newOutcome').touched || addOrEditCallLog.get('newOutcome').dirty">
              <p *ngIf="addOrEditCallLog.get('newOutcome').errors?.required" class="f-12 mt-1 text-danger">
                  Outcomes Name is required
              </p>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer b pb-5">
      <button data-testid="auto-app-edit-call-log-settings-button-2" type="submit" class="btn-trms-small m-auto" data-dismiss="modal" value="Save"> Save </button>
  </div>
</form>

